import React from 'react'

import { EuiSpacer} from '@elastic/eui'

import APIGlossar from 'components/Search/APISearchGlossar'

import ReactiveSearch from 'components/Search/APISearch'

import SEOHelmet from 'components/Layout/SEOHelmet'
import BreadCrumbs from 'components/Layout/BreadCrumbs'





const seodata = {
  title: 'INSTAR Wiki :: Wissensdatenbank für IP Kameras und Hausautomatisierung',
  description: 'Fragen zu Ihren Kameras, der Netzwerktechnik oder der Smart-System-Integration? Hier bieten wir fachkundige Anleitungen rund um IP Kameras und smarte Integrationsmöglichkeiten an.',
  image: '/images/Search/QI_SearchThumb_SetupWizard.png',
  twitter: '/images/Search/QI_SearchThumb_SetupWizard.webp'
}


export default function FrontGrid(props) {

  return (
    <React.Fragment>
        <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location="/en/" />
        <BreadCrumbs locationBC={props.location} crumbLabel="API Search" />
        <h1>API Dokumentation</h1>
        <p>HTTP und MQTT Schnittstelle</p>
        <EuiSpacer />
        <APIGlossar />
        <EuiSpacer />
        <ReactiveSearch />
    </React.Fragment>
  );
}